import { usePopups } from '@/hooks/useBanner';
import { formatMiniAppLink } from '@/utils/mini-app-link';
import i18next from 'i18next';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router';

const POPUP_CLICKED_KEY = 'popup-clicked';

function getClickedPopupIds(): number[] {
    try {
        const ids = JSON.parse(localStorage.getItem(POPUP_CLICKED_KEY) || '[]');
        return Array.isArray(ids) ? ids : [];
    } catch {
        return [];
    }
}

function saveClickedPopupId(id: number) {
    try {
        const ids = getClickedPopupIds();
        if (!ids.includes(id)) {
            localStorage.setItem(
                POPUP_CLICKED_KEY,
                JSON.stringify([...ids, id])
            );
        }
    } catch {
        // ignore storage errors
    }
}

export function PopupRandom() {
    const { data } = usePopups(i18next.language);
    const [popup, setPopup] = useState<{
        imageUrl: string;
        inAppBrowserUrl: string;
        isInApp: boolean;
        isDisplay: boolean;
        isPopup: boolean;
        orderId: number;
        navigateTo: string;
        appId: string;
        lang: string;
        id: number;
        oneTimeDisplay?: boolean;
    }>();

    useEffect(() => {
        if (!data?.sliderImages || data.sliderImages.length === 0) {
            return () => {};
        }
        const clicked = getClickedPopupIds();
        const candidates = data.sliderImages.filter(
            (item) => !(item.oneTimeDisplay && clicked.includes(item.id))
        );
        if (candidates.length === 0) {
            return () => {};
        }
        setTimeout(() => {
            const index = Math.floor(Math.random() * candidates.length);
            const item = candidates[index];
            setPopup(item);
        }, 1000);
    }, [data?.sliderImages]);

    if (!popup) {
        return null;
    }

    return (
        <>
            {createPortal(
                <div
                    className="fixed inset-0 z-[99999] bg-black/65 cursor-pointer flex items-center justify-center p-4"
                    onClick={() => {
                        setPopup(undefined);
                    }}
                >
                    <div className="flex flex-col gap-4 items-center justify-center w-full relative">
                        <Link
                            className="w-full block"
                            to={formatMiniAppLink(popup.navigateTo)}
                            data-action={`popup-id-${popup.id}`}
                            onClick={() => {
                                if (popup.oneTimeDisplay) {
                                    saveClickedPopupId(popup.id);
                                }
                            }}
                            target={
                                popup.navigateTo.startsWith('http')
                                    ? '_blank'
                                    : '_self'
                            }
                        >
                            <img
                                src={popup.imageUrl}
                                className="w-full h-full object-contain rounded-xl"
                            />
                        </Link>
                        <div
                            className=""
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setPopup(undefined);
                            }}
                        >
                            <img
                                src="/images/aion/close.webp"
                                className="w-8 h-8"
                            />
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
}
